<template>
  <div class="main mainT2">
      <div class="testT-section testT2 v3">
          <div class="example-img">
            <img src="../../assets/imageTests/posture_assis_debout.png" alt="image test 4" class="img-test4">
          </div>
          <div class="bloc2 blocTest4">
            <div class="explication1 explication4">
              <p>Assis sur une chaise, bras croisés sur la poitrine.</p>
              <p>Effectuer des mouvement assis debout durant 30 Secondes.</p> 
              <p>Compter le nombre de levés</p> 
            </div>
      <div :class="['timer-responsive'/*, 'portable2'*/, nbActived !== true ? 'vueActiveTime1' : 'vueNoneTime']">
        <div :class="['horloge']"><BaseTimer stop = 1 timeLimit = 30 @clickOnStart="onClic()" /></div>
      </div>
      <div :class="['compteur', 'compteur-portable', 'compteur-responsive', nbActived == true ? 'vueActiveCom0' : 'vueNoneCom01']">
              <label for="nb_leves" :class="['label', nbActived == true ? 'vueActiveTimeLab' : 'vueNoneTimeLab']"><p>Combien de fois vous êtes vous levés ?</p></label>
              <div :class="['compteur2', nbActived == true ? 'vueActiveTimeCom' : 'vueNoneTimeCom']">
              <button class="moins" @click.prevent="lessMesure('leve'), send(nb_leves)"><i class="fa fa-minus" aria-hidden="true"></i></button>
                <select id="nb_leves" class="selectRes" v-model="nb_leves" required @change="send(nb_leves)">
                  <option v-for="op in optionSe" :key="op" :value="op" >{{op}}</option>
                </select>
              <button class="plus" @click.prevent="addMesure('leve'), send(nb_leves)"><i class="fa fa-plus" aria-hidden="true"></i></button>    
            </div>
        </div>
          
          
        </div>
      </div>
      <div class="mainT4 portableP">
      <div class="testT-section-portable">
      <div class="example-img-portable img3">
          <img src="../../assets/imageTests/posture_assis_debout.png" alt="image test 4" class="img-test4">
      </div>
      <div class="bloc2-portable">
        <div class="explication1 explication1-portable explication4.portable">
              <p>Assis sur une chaise, bras croisés sur la poitrine.</p>
              <p>Effectuer des mouvement assis debout durant 30 Secondes.</p> 
              <p>Compter le nombre de levés</p> 
        </div>
      </div>
    </div>
      <div :class="['timer-portable'/*, 'portable2'*/, nbActived !== true ? 'vueActiveTime' : 'vueNoneTime']">
        <div :class="['horloge']"><BaseTimer stop = 1 timeLimit = 30 @clickOnStart="onClic()" /></div>
      </div>
      <div :class="['compteur', 'compteur-portable', nbActived == true ? 'vueActiveCom0' : 'vueNoneCom0']">
              <label for="nb_leves" :class="['label', nbActived == true ? 'vueActiveTimeLab' : 'vueNoneTimeLab']"><p>Combien de fois vous êtes vous levés ?</p></label>
              <div :class="['compteur2', nbActived == true ? 'vueActiveTimeCom' : 'vueNoneTimeCom']">
              <button class="moins" @click.prevent="lessMesure('leve'), send(nb_leves)"><i class="fa fa-minus" aria-hidden="true"></i></button>
                <select id="nb_leves" v-model="nb_leves" required @change="send(nb_leves)">
                  <option v-for="op in optionSe" :key="op" :value="op" >{{op}}</option>
                </select>
              <button class="plus" @click.prevent="addMesure('leve'), send(nb_leves)"><i class="fa fa-plus" aria-hidden="true"></i></button>    
            </div>
        </div>
        </div>
  </div>
</template>

<script>

import BaseTimer from '@/components/BaseTimer';

export default {
  name: "Test_4",
  components: { BaseTimer },
  data() {
    return {
        timeStop: BaseTimer.data,
        timeMax: 15,
        result: '',
        nb_leves : 0,
        nbActived : false,
    };
  },
  created(){
    this.optionSe = [];
    for (let index = 0; index < 100; index++) {
      this.optionSe[index] = index;
    }
  },
  methods: {
    onStop() {
      this.timeStop = document.getElementById('timer__label').innerHTML;
    },
    addMesure (att){
      if (att === 'leve' && this.nb_leves < 1000){
        this.nb_leves++;
      }
    },
    lessMesure (att){
      if (att === 'leve' && this.nb_leves > 1){
        this.nb_leves--;
      }     
    },
    verif(){
      this.timeStop = document.getElementById('timer__label').innerHTML;
      //console.log(this.nbActived, this.timeStop);
      if (this.timeStop == 0 || this.timeStop < 5 || this.timeStop == 30){
        this.nbActived = true;
      }else {
        this.nbActived = false;
      }
    },
    onClic(){
      if (this.nbActived == false){
      setTimeout(()=> this.verif(), 31000);
    }
    },
    send(data){
      localStorage.vive = data;
      this.$emit('choice4');
    }
  },

};
</script>

<style>
.mainT4{
  position: relative;
  width: 100%;
  min-height: 600px;
  height: 100%;
}
.vueActiveTime {
    position: absolute !important;
    visibility: visible;
    transform: translateX(0px) !important;
    opacity: 1 !important;
    transition: visibility 2s, opacity 1.5s, transform 1.5s linear !important;
}
.vueActiveTime1 {
    position: relative !important;
    visibility: visible;
    transform: translateX(0px) !important;
    opacity: 1 !important;
    transition: visibility 2s, opacity 1.5s, transform 1.5s linear !important;
}

.vueNoneTime {
    position: absolute !important;
    visibility: hidden;
    opacity: 0 !important;
    transform: translateX(+30px) !important;
    transition: visibility 1s, opacity 1s, linear !important;
}
/*
.vueActiveTime0 {
    position: relative !important;
    display: block;
    opacity: 1 !important;
    transition: display 1.1s, opacity 1s, linear !important;
}

.vueNoneTime0 {
    position: relative !important;
    display:none;
    opacity: 0 !important;
    transition: display 1.1s, opacity 1s !important;
}
.vueActiveCom0 {
    position: relative !important;
    display: block;
    opacity: 1 !important;
    transition: display 0.5s, opacity 1.5s, linear !important;
}

.vueNoneCom0 {
    position: relative !important;
    display: none;
    opacity: 0 !important;
    transform: translateX(+30px) !important;
    transition: display 0.5s, opacity 1s, transform 1s linear !important;
}*/
.vueNoneCom01 {
    background: transparent;
}
.vueActiveTimeLab {
    position: relative !important;
    visibility: visible;
    opacity: 1 !important;
    top: 10px;
    transform: translateX(0px) !important;
    transition: visibility 2s, opacity 1.5s, transform 1.5s linear !important;
}

.vueNoneTimeLab {
    position: relative !important;
    visibility: hidden;
    opacity: 0 !important;
    top: 10px;
    transform: translateX(+30px) !important;
    transition: visibility 1s, opacity 1s, transform 1s linear !important;
}
.vueActiveTimeCom {
    position: relative !important;
    visibility: visible;
    top: 25px;
    opacity: 1 !important;
    transform: translateX(0px) !important;
    transition: visibility 2s, opacity 1.5s, transform 1.5s linear !important;
}

.vueNoneTimeCom {
    position: relative !important;
    visibility: hidden;
    opacity: 0 !important;
    top: 25px;
    transform: translateX(+30px) !important;
    transition: visibility 1s, opacity 1s, transform 1s linear !important;
}

#nb_leves{
  -webkit-appearance: none;
	-moz-appearance: none;
  appearance: none;
  text-overflow: ellipsis;
  font-family: "Myriad Pro Light";
  font-size: 1.1em;
  text-align: center;
  padding-left: 30%;
  border: none;
  border-radius: 8px;
}
.selectRes{
  padding-left: 38% !important;
}
.compteur-responsive{
  background: transparent;
}

</style>


// WEBPACK FOOTER //
// src/components/Test/Test_4.vue